import { httpClient } from './base';

// 用户管理接口
export interface User {
  id: number;
  username: string;
  email: string;
  nickname: string;
  avatar?: string;
  phone?: string;
  gender?: number;
  gender_text?: string;
  birthday?: string;
  status: number;
  status_text: string;
  is_admin: boolean;
  last_login_at?: string;
  login_ip?: string;
  created_at: string;
  updated_at: string;
}

export interface UserData {
  users: User[];
  pagination: Pagination;
}

export interface UserPageParams extends PaginationParams {
  status?: number;
  is_admin?: boolean;
}

// 公司管理接口
export interface Company {
  id: number;
  name: string;
  legal_representative: string;
  registration_number: string;
  unified_social_credit_code?: string;
  company_type?: string;
  registration_date?: string;
  registered_capital?: number;
  business_scope?: string;
  registration_address?: string;
  business_address?: string;
  contact_phone: string;
  contact_email: string;
  website?: string;
  status: number;
  remark?: string;
}

// 部门管理接口
export interface Department {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  employee_count: number;
  manager: string;
  company:{
    id: number;
    name: string;
  };
  positions:
  {
    position_name: string;
    employee_id: number;
    description: string;
    display_order: number;
    employee_name?: string;
    id: number;
  }[]
}

// 新增部门表单数据
export interface DepartmentCreateForm {
  id?: number;
  name: string;
  positions:
  {
    position_name: string;
    employee_id: number;
    description: string;
    display_order: number;
  }[]
}

// 员工管理接口
export interface Employee {
  id: number;
  name: string;
  gender: string;
  company?: {
    id: number;
    name: string;
  };
  department?: Department;
  hire_date: string;
  education: string;
  political_status: string;
  birthday_type: string;
  birthday: string;
  salary_payment_method: string;
  phone_number: string;
  participate_seniority_calculation: boolean;
  seniority: number;
  created_at: string;
  updated_at: string;
  id_card_image_url?: string;
  id_card_number?: string;
  position?: string;
  driver_license_front_url?: string;
  driver_license_back_url?: string;
  id_card_front_url?: string;
  id_card_back_url?: string;
  user_id?: number;
}

export interface EmployeeDetail {
  id: number;
  name: string;
  gender: string;
  department: {
    id: number;
    name: string;
    employee_count: number;
    manager: string;
    created_at: Date;
    updated_at: Date;
  };
  hire_date: Date;
  education: string;
  political_status: string;
  birthday_type: string;
  birthday: Date;
  salary_payment_method: string;
  phone_number: string;
  participate_seniority_calculation: boolean;
  seniority: number;
  status: string;
  resignation_date: null;
  user_id: number;
  employee_number: string;
  position: string;
  created_at: Date;
  updated_at: Date;
  id_card_image_url?: string;
  id_card_number?: string;
  driver_license_front_url?: string;
  driver_license_back_url?: string;
  id_card_front_url?: string;
  id_card_back_url?: string;
  emergency_contact?: string;
  emergency_contact_phone?: string;

}

// 入驻申请管理接口
export interface CompanyApplication {
  id: number;
  user_id: number;
  company_id: number;
  company_name: string;
  name: string;
  phone: string;
  position: string;
  remark: string;
  attachments: string;
  gender: string;
  id_card_number: string;
  id_card_front_url: string;
  id_card_back_url: string;
  driver_license_front_url: string;
  driver_license_back_url: string;
  department_id: number;
  education: string;
  political_status: string;
  birthday_type: string;
  birthday: Date;
  status: string;
  reviewed_by: null;
  reviewed_at: null;
  reject_reason: string;
  created_at: Date;
  updated_at: Date;
}

// 分页参数接口
export interface PaginationParams {
  page?: number;
  page_size?: number;
  keyword?: string;
}


// 分页响应接口
export interface PaginationResponse<T> {
  items: T[];
  total: number;
  current_page: number;
  per_page: number;
  total_pages: number;
}

interface Response<T> {
  success: boolean;
  message: string;
  data: T;
}

interface Pagination {
  page: number
  page_size: number
  pages: number
  total: number
}

interface CompanyData {
  companies: Company[];
  pagination: Pagination;
}

export interface CompanyPageParams extends PaginationParams {
  status?: number;
}

interface DepartmentData {
  departments: Department[];
  total: number;
}

interface EmployeeData {
  employees: Employee[];
  pagination: Pagination;
}

interface CompanyApplicationData {
  applications: CompanyApplication[];
  pagination: Pagination;
}

export interface CompanyApplicationPageParams extends PaginationParams {
  status?: 'pending' | 'approved' | 'rejected';
}

export interface CompanyApplicationDecision {
  decision: 'approved' | 'rejected';
  remark?: string;
  reject_reason?: string
}

// 异常考勤确认接口（管理员端）
export interface AttendanceConfirmation {
  id: number;
  confirmation_type: number;
  confirmation_type_text: string;
  reason: string;
  evidence?: string;
  status: number;
  status_text: string;
  approval_comment?: string;
  approved_at?: string;
  created_at: string;
  updated_at?: string;
  attendance: {
    id: number;
    work_date: string;
    clock_in_time?: string | null;
    clock_out_time?: string | null;
    status: number;
    status_text: string;
  };
  employee: {
    id: number;
    name: string;
    phone: string;
  };
  requester?: {
    id: number;
    name: string;
    phone: string;
  };
  approver?: {
    id: number;
    name: string;
    phone: string;
  };
}

interface AttendanceConfirmationData {
  confirmations: AttendanceConfirmation[];
  pagination: Pagination;
}

export interface AttendanceConfirmationPageParams extends PaginationParams {
  status?: number;
  confirmation_type?: number;
  employee_id?: number;
  company_id?: number;
}

export interface BatchApproveConfirmationsData {
  confirmation_ids: number[];
  approval_comment?: string;
}

export interface ApproveConfirmationData {
  approval_comment?: string;
}

export interface AttendanceConfirmationStatsData {
  total_count: number;
  pending_count: number;
  approved_count: number;
  rejected_count: number;
  today_count: number;
  this_month_count: number;
  late_arrival_count: number;
  early_depart_count: number;
  absence_count: number;
  missing_card_count: number;
}

// 考勤规则管理接口
export interface AttendanceRule {
  id: number;
  name: string;
  description?: string;
  work_start_time: string;
  work_end_time: string;
  break_start_time?: string;
  break_end_time?: string;
  late_threshold: number; // 迟到阈值（分钟）
  early_leave_threshold: number; // 早退阈值（分钟）
  overtime_threshold: number; // 加班阈值（分钟）
  work_days: string; // 工作日（1-7，1为周一）
  flexible_time: boolean; // 是否弹性工作制
  flexible_minutes?: number; // 弹性时间（分钟）
  status: number; // 状态：1-启用，0-禁用
  status_text: string;
  created_at: string;
  updated_at: string;
  allowed_latitude?: number;
  allowed_longitude?: number;
  group?: {
    id: number;
    name: string;
    description: string;
    company_id: number;
    manager_id: number;
    status: number;
    status_text: string;
    employee_count: number;
    rule_count: number;
    created_at: string;
    updated_at: string;
  };
}

export interface AttendanceRuleData {
  rules: AttendanceRule[];
  pagination: Pagination;
}

export interface AttendanceRulePageParams extends PaginationParams {
  status?: number;
  name?: string;
}

export interface CreateAttendanceRuleData {
  name: string;
  work_start_time: string;
  work_end_time: string;
  break_start_time?: string;
  break_end_time?: string;
  late_threshold: number;
  early_leave_threshold: number;
  overtime_threshold: number;
  work_days: string;
  is_flexible: boolean;
  flexible_minutes?: number;
  required_work_hours: number
}

// 考勤组管理接口
export interface AttendanceGroup {
  id: number;
  name: string;
  description?: string;
  company_id: number;
  company: {
    id: number;
    name: string;
  };
  manager_id?: number;
  manager?: {
    id: number;
    name: string;
    phone?: string;
  },
  status: number;
  status_text: string;
  employee_count: number;
  rule_count: number;
  created_at: string;
  updated_at: string;
}


export interface AttendanceGroupData {
  groups: AttendanceGroup[];
  pagination: Pagination;
}

export interface AttendanceGroupPageParams extends PaginationParams {
  status?: number;
  name?: string;
  rule_id?: number;
}

export interface CreateAttendanceGroupData {
  name: string;
  description?: string;
  rule_id: number;
  manager_id?: number;
  status?: number;
}

export interface AttendanceGroupEmployee {
  id: number;
  employee_id: number;
  employee: Employee;
  group_id: number;
  joined_at: string;
}

export interface AddEmployeesToGroupData {
  employee_ids: number[];
}

export interface AttendanceGroupEmployeeData {
  id: number;
  name: string;
  phone: string;
}

// 考勤记录相关接口
export interface AttendanceRecord {
  id: number;
  employee_id: number;
  employee: {
    id: number;
    name: string;
    phone: string;
  };
  rule_id: number;
  clock_in_time: Date;
  clock_out_time: Date;
  clock_in_lat: number;
  clock_in_lng: number;
  clock_out_lat: number;
  clock_out_lng: number;
  work_date: Date;
  status: number;
  status_text: string;
  work_hours: number;
  late_minutes: number;
  early_minutes: number;
  note: string;
  created_at: Date;
  updated_at: Date;
}

export interface AttendanceRecordData {
  records: AttendanceRecord[];
  pagination: Pagination;
}

export interface AttendanceRecordPageParams extends PaginationParams {
  employee_id?: number;
  company_id?: number;
  group_id?: number;
  status?: string;
  start_date?: string;
  end_date?: string;
  attendance_date?: string;
}

export interface AttendanceRecordCreateData {
  employee_id: number;
  employee_name: string;
  phone_number: string;
  user_id: number;
  roles: null;
  department_id: number;
  department_name: string;
  employee_number: string;
  companies: {
    company_id: number;
    company_name: string;
    role: string;
    status: number;
    status_text: string;
    joined_at: string;
    left_at: null;
    company: {
      id: number;
      name: string;
      legal_representative: string;
      registration_number: string;
      unified_social_code: string;
      company_type: string;
      registration_date: string;
      registered_capital: string;
      business_scope: string;
      registered_address: string;
      operating_address: string;
      contact_phone: string;
      contact_email: string;
      website: string;
      status: number;
      remark: string;
      created_at: string;
      updated_at: string;
    };
  }[];
}

// 薪资管理接口
export interface Salary {
  id: number;
  employee_id: number;
  employee_name: string;
  month: string;
  net_salary: number;
  status: string;
  payment_date: null;
  category_id?: number;
  income: {
    basic_salary: number;
    seniority_pay: number;
    performance_pay: number;
    overtime_pay: number;
    bonus: number;
    allowance: number;
    total: number;
  };
  deductions: {
    attendance_deduction: number;
    personal_insurance: number;
    personal_tax: number;
    housing_fund: number;
    other_deductions: number;
    total: number;
  };
  summary: {
    total_income: number;
    total_deductions: number;
    net_salary: number;
  };
  remarks: string;
  created_at: Date;
  updated_at: Date;

}

export interface SalaryData {
  salaries: Salary[];
  pagination: Pagination;
}

export interface SalaryPageParams extends PaginationParams {
  employee_id?: number;
  month?: string;
  status?: string;
}

export interface CreateSalaryData {
  employee_id: number;
  month: string;
  // 收入项
  basic_salary: number; // 基础工资
  seniority_pay?: number; // 工龄工资
  performance_pay?: number; // 绩效工资
  overtime_pay?: number; // 加班费
  bonus?: number; // 奖金
  allowance?: number; // 津贴
  category_id?: number; // 薪资分类ID
  payment_date?: string; // 发放日期
  // 扣除项
  attendance_deduction?: number; // 考勤扣款
  personal_insurance?: number; // 个人保险
  personal_tax?: number; // 个人所得税
  housing_fund?: number; // 公积金
  other_deductions?: number; // 其他扣款
  status?: number;
  remark?: string;
}

export interface BatchUpdateSalaryStatusData {
  ids: number[];
  status: string;
}

export interface SalaryStatsData {
  total_employees: number,
  total_salaries: number,
  avg_salary: number,
  max_salary: number,
  min_salary: number
}

// 薪资项目分类管理接口
export interface SalaryItemCategory {
  id: number;
  name: string;
  type: '扣除' | '收入';
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface SalaryItemCategoryData {
  categories: SalaryItemCategory[];
  pagination: Pagination;
}

export interface SalaryItemCategoryPageParams extends PaginationParams {
  name?: string;
  type?: string;
  status?: number;
}

export interface CreateSalaryItemCategoryData {
  name: string;
  type: 'income' | 'deduction';
  description?: string;
}

export interface UpdateSalaryItemCategoryData {
  name?: string;
  type?: string;
  description?: string;
  is_active?: boolean;
}

// 银行账户管理接口
export interface BankAccount {
  id: number;
  employee_id: number;
  bank_name: string;
  account_name: string;
  card_number: string;
  is_default: boolean;
  created_at: Date;
  updated_at: Date;
}

export interface BankAccountData {
  bank_accounts: BankAccount[];
  pagination: Pagination;
}

export interface BankAccountPageParams extends PaginationParams {
  employee_id?: number;
  bank_name?: string;
  status?: number;
}

export interface CreateBankAccountData {
  employee_id: number;
  bank_name: string;
  card_number: string;
  account_name: string;
  bank_branch?: string;
  account_type: string;
  is_default?: boolean;
  status?: number;
}

export interface SetDefaultBankAccountData {
  account_id: number;
}

// 合同管理相关接口定义
export interface Contract {
  id: number;
  employee_id: number;
  contract_type: string;
  company_subject: string;
  signing_date: string;
  expiration_date: string;
  created_at: string;
  updated_at: string;
}

export interface CreateContractData {
  employee_id: number;
  contract_type: string;
  contract_number: string;
  start_date: string;
  end_date?: string;
  salary: number;
  position: string;
  department?: string;
  contract_content?: string;
  attachment_url?: string;
  status?: number;
}


// 消息管理相关接口定义
export interface Message {
  id: number;
  title: string;
  content: string;
  type: string;
  priority: string;
  sender_id: number;
  sender: {
    id: number;
    username: string;
    email: string;
    nickname: string;
    avatar: string;
    phone: string;
    gender: number;
    gender_text: string;
    birthday: null;
    status: number;
    status_text: string;
    is_admin: boolean;
    last_login_at: null;
    login_ip: string;
    created_at: Date;
    updated_at: Date;
  };
  recipients?: {
    id: number;
    message_id: number;
    recipient_id: number;
    recipient: {
      id: number;
      username: string;
      email: string;
      nickname: string;
      avatar: string;
      phone: string;
      gender: number;
      gender_text: string;
      birthday: null;
      status: number;
      status_text: string;
      is_admin: boolean;
      last_login_at: null;
      login_ip: string;
      created_at: Date;
      updated_at: Date;
    };
    is_read: boolean;
    read_at: null;
    is_archived: boolean;
    archived_at: null;
    created_at: Date;
    updated_at: Date;
  }[],
  is_global: boolean;
  expires_at: null;
  published_at: null;
  is_active: boolean;
  is_expired: boolean;
  is_published: boolean;
  created_at: Date;
  updated_at: Date;
}

export interface MessageData {
  messages: Message[];
  pagination: Pagination;
}

export interface MessagePageParams extends PaginationParams {
  type?: string;
  status?: string;
  priority?: number;
}

export interface CreateMessageData {
  title: string;
  content: string;
  type: string;
  priority: number;
  recipient_ids?: number[];
  send_time?: string;
  expire_time?: string;
}

export interface AddRecipientsData {
  recipient_ids: number[];
}

export interface CreateGlobalMessageData {
  title: string;
  content: string;
  type: string;
  priority: number;
}



// 通讯录管理相关接口
export interface Contact {
  id: number;
  name: string;
  department: string;
  position: string;
  phone: string;
  email: string;
  avatar: string;
  hire_date: Date;
  status: string;
  created_at: Date;
  updated_at: Date;
}

export interface ContactData {
  contacts: Contact[];
  pagination: {
    current_page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
}

export interface ContactPageParams extends PaginationParams {
  department_id?: number;
  status?: number;
  search?: string;
  company_id?: number;
}

export interface CreateContactData {
  employee_id: number;
  is_public?: boolean;
  display_order?: number;
  custom_title?: string;
}

export interface UpdateContactData {
  employee_id?: number;
  is_public?: boolean;
  display_order?: number;
  custom_title?: string;
  status?: number;
}

export interface ContactStatsData {
  total_contacts: number;
  synced_contacts: number;
  unsynced_contacts: number;
  active_contacts: number;
  inactive_contacts: number;
  department_stats: {
    department_id: number;
    department_name: string;
    contact_count: number;
  }[];
}

export interface SyncContactData {
  employee_id: number;
}

export interface BatchSyncContactData {
  employee_ids: number[];
}

// 权限管理相关接口
export interface Permission {
  id: number;
  name: string;
  display_name: string;
  description: string;
  resource: string;
  action: string;
  status: number;
  status_text: string;
  created_at: string;
  updated_at: string;
}

export interface PermissionData {
  list: Permission[];
  pagination: Pagination;
}

export interface PermissionPageParams extends PaginationParams {
  name?: string;
  resource?: string;
  action?: string;
}

export interface CreatePermissionData {
  name: string;
  description?: string;
  resource: string;
  action: string;
}

// 角色管理相关接口
export interface Role {
  id: number;
  name: string;
  display_name: string;
  description: string;
  status: number;
  status_text: string;
  created_at: string;
  updated_at: string;
}

export interface RoleData {
  list: Role[];
  pagination: Pagination;
}

export interface RolePageParams extends PaginationParams {
  name?: string;
}

export interface CreateRoleData {
  name: string;
  description?: string;
}

export interface RolePermissionData {
  role_id: number;
  ids: {
    role: string;
    resource: string;
    action: string;
    // role_id: number;
  }[];
}

export interface RoleAssignData {
  user_id: number;
  role: string;
}

export interface RoleRevokeData {
  user_id: number;
  role: string;
}

export interface PermissionAssignData {
  role_id: number;
  permission_id: number;
}

export interface AddRolePermissionData {
  role: string
  resource: string,
  action: string
}

export interface RemoveRolePermissionData {
  role: string
  resource: string
  action: string
}


export interface RoleData {
  role: string;
  permissions: string[][];
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  code: number;
  message: string;
  data: {
    token: string;
    token_type: string;
    expires_in: number;
    user: {
      id: number;
      username: string;
      email: string;
      nickname: string;
      is_admin: boolean;
    };
  };
}

export interface UserProfile {
  id: number;
  avatar: string;
  username: string;
  email: string;
  nickname: string;
  is_admin: boolean;
}

export interface OSSUploadResponse {
  file_name: string;
  file_path: string;
  file_size: number;
  content_type: string;
  etag: string;
  last_modified: Date;
  is_public: boolean;
  description: string;
  access_url: string;
  download_url: string;
  upload_time: Date;
  uploader_id: number;
  uploader_name: string;
}

interface ContactDepartment {
  id: number;
  name: string;
  employee_count: number;
}

// 假期审批相关接口
export interface LeaveRequest {
  id: number;
  employee_id: number;
  employee: {
    id: number;
    name: string;
    phone_number: string;
    department?: {
      id: number;
      name: string;
    };
  };
  leave_type: string;
  start_date: string;
  end_date: string;
  start_time?: string;
  end_time?: string;
  days: number;
  hours?: number;
  reason: string;
  emergency_contact?: string;
  emergency_phone?: string;
  attachment_urls?: string[];
  status: 'pending' | 'approved' | 'rejected' | 'cancelled' | 'withdrawn';
  status_text: string;
  current_approval_level: number;
  total_approval_levels: number;
  created_at: string;
  updated_at: string;
  approval_records: LeaveApprovalRecord[];
}

export interface LeaveApprovalRecord {
  id: number;
  leave_request_id: number;
  approver_id: number;
  approver: {
    id: number;
    name: string;
    phone_number: string;
  };
  approval_level: number;
  status: 'pending' | 'approved' | 'rejected';
  status_text: string;
  comment?: string;
  approved_at?: string;
  created_at: string;
  updated_at: string;
}

export interface LeaveRequestData {
  data?: LeaveRequest[];
  total: 0;
  page: 1;
  page_size: 10;
  total_pages: 0
}

export interface LeaveRequestPageParams extends PaginationParams {
  status?: 'pending' | 'approved' | 'rejected' | 'cancelled' | 'withdrawn';
  leave_type?: string;
  employee_id?: number;
  start_date?: string;
  end_date?: string;
  approval_level?: number;
}

export interface LeaveApprovalData {
  decision: 'approved' | 'rejected';
  comment?: string;
  approval_level: number;
}

export interface BatchLeaveApprovalData {
  request_ids: number[];
  decision: 'approved' | 'rejected';
  comment?: string;
  approval_level: number;
}

// 排班管理相关接口
export interface Schedule {
  id: number;
  employee_id: number;
  employee: Employee;
  date: string;
  shift_type: string;
  status: '正常' | '请假' | '调休' | '加班';
  remark?: string;
  created_at: string;
  updated_at: string;
}

export interface ScheduleData {
  data?: Schedule[];
  total?: number;
  page?: number;
  page_size?: number;
  total_pages?: number;
}

export interface SchedulePageParams extends PaginationParams {
  start_date?: string;
  end_date?: string;
  employee_ids?: string; // 逗号分隔的员工ID
  shift_type?: string;
  status?: string;
}

export interface CreateScheduleData {
  employee_id: number;
  date: string;
  shift_type: string;
  status?: '正常' | '请假' | '调休' | '加班';
  remark?: string;
}

export interface UpdateScheduleData {
  shift_type?: string;
  status?: '正常' | '请假' | '调休' | '加班';
  remark?: string;
}

export interface BatchCreateScheduleData {
  schedules: CreateScheduleData[];
}

export interface BatchDeleteScheduleData {
  schedule_ids: number[];
}

export interface CopyScheduleData {
  source_date: string;
  source_end_date?: string; // 复制日期范围时使用
  target_date: string;
  employee_ids?: number[]; // 复制指定员工时使用
}

export interface ValidateScheduleData {
  schedules: CreateScheduleData[];
}

export interface ScheduleValidationResult {
  is_valid: boolean;
  conflicts: {
    employee_id: number;
    date: string;
    message: string;
  }[];
}

// 班次类型接口
export interface ShiftType {
  id: number;
  name: string;
  code: string;
  start_time: string;
  end_time: string;
  description: string;
  is_active: boolean;
  sort_order: number;
  created_at: Date;
  updated_at: Date;
}

export interface ShiftTypeData {
  data?: ShiftType[];
}

export interface ShiftTypePageParams extends PaginationParams {
  name?: string;
  is_active?: boolean;
}

export interface CreateShiftTypeData {
  name: string;
  start_time: string;
  end_time: string;
  break_duration?: number;
  work_hours: number;
  color?: string;
  description?: string;
  is_active?: boolean;
}

// 排班员工接口（用于排班选择）
export interface ScheduleEmployee {
  id: number;
  name: string;
  phone_number?: string;
  department?: {
    id: number;
    name: string;
  };
  position?: string;
  status: string;
}

// 假期类型管理相关接口
export interface LeaveType {
  id: number;
  name: string;
  code: string;
  description?: string;
  requires_proof: boolean;
  requires_approval: boolean;
  approval_levels: number;
  max_days?: number;
  min_days?: number;
  unit: 'day' | 'hour';
  has_balance: boolean;
  can_transfer: boolean;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface LeaveTypeData {
  data: LeaveType[];
}

export interface LeaveTypePageParams extends PaginationParams {
  name?: string;
  code?: string;
  is_active?: boolean;
}

export interface CreateLeaveTypeData {
  name: string;
  code: string;
  description?: string;
  requires_proof?: boolean;
  requires_approval?: boolean;
  approval_levels?: number;
  max_days?: number;
  min_days?: number;
  unit?: 'day' | 'hour';
  has_balance?: boolean;
  can_transfer?: boolean;
  is_active?: boolean;
  sort_order?: number;
}

export interface HolidayBalanceUpdateData {
  leave_type: string;
  year: number;
  total_days: number;
  transferred_days: number;
}

export interface HolidayBalance {
  id: number;
  employee_id: number;
  employee: Employee
  leave_type: string;
  year: number;
  total_days: number;
  used_days: number;
  remaining_days: number;
  transferred_days: number;
  last_updated_at: Date;
  created_at: Date;
}

// 日报管理相关接口
export interface DailyReport {
  id: number;
  created_at: Date;
  updated_at: Date;
  employee_id: number;
  employee: Employee;
  report_date: Date;
  today_work: string;
  tomorrow_plan: string;
  problems: string;
  need_help: string;
  work_hours: number;
  status: string;
  submitted_at: Date;
  department_id: number;
  department: Department;
}

interface DailyReportData {
  reports: DailyReport[];
  pagination: Pagination;
}

export interface DailyReportPageParams extends PaginationParams {
  employee_id?: number;
  department_id?: number;
  start_date?: string;
  end_date?: string;
  status?: string;
}

export interface UpdateDailyReportData {
  title?: string;
  content?: string;
  work_hours?: number;
  status?: string;
}

export interface DailyReportStatsData {
  avg_work_hours: number;
  draft_reports: number;
  submit_rate: number;
  submitted_reports: number;
  total_reports: number;
  total_work_hours: number;
}

export interface DailyReportComment {
  id: number;
  daily_report_id: number;
  content: string;
  commenter_id: number;
  commenter: {
    id: number;
    name: string;
    phone: string;
  };
  is_admin_reply: boolean;
  parent_id?: number;
  created_at: string;
  updated_at: string;
}

export interface CreateDailyReportCommentData {
  content: string;
  parent_id?: number;
}

export const adminApi = {
  // 登录
  login: (data: LoginRequest) => {
    return httpClient.post<LoginResponse>('/auth/login', data);
  },

  // 通讯录管理
  contacts: {
    list: (params?: ContactPageParams) => {
      return httpClient.get<Response<ContactData>>('/public/contacts', { params });
    },

    create: (data: CreateContactData) => {
      return httpClient.post<Response<Contact>>('/admin/contacts', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<Contact>>(`/public/contacts/${id}`);
    },

    update: (id: number, data: UpdateContactData) => {
      return httpClient.put<Response<Contact>>(`/admin/contacts/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/admin/contacts/${id}`);
    },

    search: (params?: { keyword?: string; department_id?: number }) => {
      return httpClient.get<Response<ContactData>>('/admin/contacts/search', { params });
    },

    getStats: () => {
      return httpClient.get<Response<ContactStatsData>>('/public/contacts/stats');
    },

    getDepartments: () => {
      return httpClient.get<Response<ContactDepartment[]>>('/public/departments');
    },

    syncEmployee: (data: SyncContactData) => {
      return httpClient.post<Response<Contact>>(`/admin/contacts/sync/${data.employee_id}`);
    },

    batchSyncEmployees: (data: BatchSyncContactData) => {
      return httpClient.post<Response<Contact[]>>('/admin/contacts/batch-sync', data);
    },
  },
  // 用户管理
  users: {
    list: (params?: UserPageParams) => {
      return httpClient.get<Response<UserData>>('/admin/users', { params });
    },

    updateStatus: (id: number, status: 1 | 0) => {
      return httpClient.put(`/admin/users/${id}/status`, { status });
    },

    resetPassword: (id: number, data?: { new_password?: string }) => {
      return httpClient.put<Response<{ new_password: string }>>(`/admin/users/${id}/reset-password`, data);
    },
  },

  // 日报管理
  dailyReports: {
    list: (params?: DailyReportPageParams) => {
      return httpClient.get<Response<DailyReportData>>('/daily-reports', { params });
    },

    detail: (id: number) => {
      return httpClient.get<Response<DailyReport>>(`/daily-reports/${id}`);
    },

    update: (id: number, data: UpdateDailyReportData) => {
      return httpClient.put<Response<DailyReport>>(`/daily-reports/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/daily-reports/${id}`);
    },

    getStats: (params?: { month?: string; department_id?: number }) => {
      return httpClient.get<Response<DailyReportStatsData>>('/daily-reports/stats', { params });
    },

    getComments: (id: number) => {
      return httpClient.get<Response<DailyReportComment[]>>(`/daily-reports/${id}/comments`);
    },

    createComment: (id: number, data: CreateDailyReportCommentData) => {
      return httpClient.post<Response<DailyReportComment>>(`/daily-reports/${id}/comments`, data);
    },

    deleteComment: (commentId: number) => {
      return httpClient.delete<Response<void>>(`/daily-reports/comments/${commentId}`);
    },
  },

  // 公司管理
  companies: {
    list: (params?: CompanyPageParams) => {
      return httpClient.get<Response<CompanyData>>('/admin/companies', { params });
    },

    create: (data: Partial<Company>) => {
      return httpClient.post<Response<Company>>('/admin/companies', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<Company>>(`/admin/companies/${id}`);
    },

    update: (id: number, data: Partial<Company>) => {
      return httpClient.put<Response<Company>>(`/admin/companies/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete(`/admin/companies/${id}`);
    },

    updateStatus: (id: number, status: 1 | 0) => {
      return httpClient.put(`/admin/companies/${id}/status`, { status });
    },

    getActive: () => {
      return httpClient.get<Company[]>('/admin/companies/active');
    },

    generateJoinQR: (id: number, data: { expires_in?: number }) => {
      return httpClient.post<Response<{ qr_token: string }>>(`/admin/companies/${id}/join-qr`, data);
    },
  },

  // 部门管理
  departments: {
    list: (params?: PaginationParams & { name?: string,company_id?: number}) => {
      return httpClient.get<Response<DepartmentData>>('/admin/departments', { params });
    },

    create: (data: Partial<DepartmentCreateForm>) => {
      return httpClient.post<Response<Department>>('/admin/departments', data);
    },

    update: (id: number, data: Partial<DepartmentCreateForm>) => {
      return httpClient.put<Response<Department>>(`/admin/departments/${id}`, data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<Department>>(`/admin/departments/${id}`);
    },

    delete: (id: number) => {
      return httpClient.delete(`/admin/departments/${id}`);
    },
  },

  // 员工管理
  employees: {
    list: (params?: PaginationParams & { department_id?: number; status?: number }) => {
      return httpClient.get<Response<EmployeeData>>('/admin/employees', { params });
    },

    create: (data: Partial<Employee>) => {
      return httpClient.post<Response<Employee>>('/admin/employees', data);
    },

    update: (id: number, data: Partial<Employee>) => {
      return httpClient.put<Response<Employee>>(`/admin/employees/${id}`, data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<EmployeeDetail>>(`/admin/employees/${id}`);
    },

    delete: (id: number) => {
      return httpClient.delete(`/admin/employees/${id}`);
    },

    getRoleCompany: (id: number) => {
      return httpClient.get<Response<AttendanceRecordCreateData>>(`/admin/employees/${id}/role-company`);
    },

    getApplicationData: (userId: number) => {
      return httpClient.get<Response<CompanyApplication>>(`/admin/employees/application-data/${userId}`);
    },
    // 查看员工假期余额
    getHolidayBalance: (id: number) => {
      return httpClient.get<Response<{ data?: HolidayBalance[] }>>(`/admin/leave-balances/${id}`);
    },
    // 设置员工假期余额
    setHolidayBalance: (id: number, data: HolidayBalanceUpdateData) => {
      return httpClient.post<Response<HolidayBalance>>(`/admin/leave-balances/${id}`, data);
    },
    // 删除员工假期余额
    deleteHolidayBalance: (id: number) => {
      return httpClient.delete(`/admin/leave-balances/${id}`);
    },
  },

  // 入驻申请管理
  companyApplications: {
    list: (params?: CompanyApplicationPageParams) => {
      return httpClient.get<Response<CompanyApplicationData>>('/admin/company-applications', { params });
    },

    detail: (id: number) => {
      return httpClient.get<Response<CompanyApplication>>(`/admin/company-applications/${id}`);
    },

    decision: (id: number, data: CompanyApplicationDecision) => {
      return httpClient.patch<Response<CompanyApplication>>(`/admin/company-applications/${id}/decision`, data);
    },
  },

  // 考勤规则管理
  attendanceRules: {
    list: (params?: AttendanceRulePageParams) => {
      return httpClient.get<Response<AttendanceRuleData>>('/admin/attendance/rules', { params });
    },

    create: (data: CreateAttendanceRuleData) => {
      return httpClient.post<Response<AttendanceRule>>('/admin/attendance/rules', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<AttendanceRule>>(`/admin/attendance/rules/${id}`);
    },

    update: (id: number, data: Partial<CreateAttendanceRuleData>) => {
      return httpClient.put<Response<AttendanceRule>>(`/admin/attendance/rules/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<AttendanceRule>>(`/admin/attendance/rules/${id}`);
    },

    updateStatus: (id: number, status: 1 | 0) => {
      return httpClient.put<Response<AttendanceRule>>(`admin/attendance/rules/${id}/status`, { status });
    },
  },

  // 考勤组管理
  attendanceGroups: {
    list: (params?: AttendanceGroupPageParams) => {
      return httpClient.get<Response<AttendanceGroupData>>('/admin/attendance/groups', { params });
    },

    create: (data: CreateAttendanceGroupData) => {
      return httpClient.post<Response<AttendanceGroup>>('/admin/attendance/groups', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<AttendanceGroup>>(`/admin/attendance/groups/${id}`);
    },

    update: (id: number, data: Partial<CreateAttendanceGroupData>) => {
      return httpClient.put<Response<AttendanceGroup>>(`/admin/attendance/groups/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<AttendanceGroup>>(`/admin/attendance/groups/${id}`);
    },

    addEmployees: (id: number, data: AddEmployeesToGroupData) => {
      return httpClient.post<{ success: boolean }>(`/admin/attendance/groups/${id}/employees`, data);
    },

    getEmployees: (id: number, params?: PaginationParams) => {
      return httpClient.get<Response<AttendanceGroupEmployeeData[]>>(`/admin/attendance/groups/${id}/employees`, { params });
    },
    removeEmployees: (id: number, data: AddEmployeesToGroupData) => {
      return httpClient.post<{ success: boolean }>(`/admin/attendance/groups/${id}/employees/remove`, data);
    },
  },

  // 考勤记录管理
  attendanceRecords: {
    list: (params?: AttendanceRecordPageParams) => {
      return httpClient.get<Response<AttendanceRecordData>>('/admin/attendance/records', { params });
    },

    detail: (id: number) => {
      return httpClient.get<Response<AttendanceRecord>>(`/admin/attendance/records/${id}`);
    },

    clearToday: () => {
      return httpClient.post<Response<{ deleted_count: number; date: string }>>('/admin/attendance/clear-today');
    },
  },

  // 异常考勤确认（管理员端）
  attendanceConfirmations: {
    // 获取所有确认申请
    list: (params?: AttendanceConfirmationPageParams) => {
      return httpClient.get<Response<AttendanceConfirmationData>>('/admin/attendance/confirmations', { params });
    },

    // 获取确认申请详情
    detail: (id: number) => {
      return httpClient.get<Response<AttendanceConfirmation>>(`/admin/attendance/confirmations/${id}`);
    },

    // 审批通过
    approve: (id: number, data: ApproveConfirmationData) => {
      return httpClient.post<Response<void>>(`/admin/attendance/confirmations/${id}/approve`, data);
    },

    // 审批拒绝
    reject: (id: number, data: ApproveConfirmationData) => {
      return httpClient.post<Response<void>>(`/admin/attendance/confirmations/${id}/reject`, data);
    },

    // 批量审批通过
    batchApprove: (data: BatchApproveConfirmationsData) => {
      return httpClient.post<Response<void>>('/admin/attendance/confirmations/batch-approve', data);
    },

    // 获取统计数据
    getStats: (params?: { company_id?: number }) => {
      return httpClient.get<Response<AttendanceConfirmationStatsData>>('/admin/attendance/confirmations/stats', { params });
    },
  },

  // 薪资管理
  salaries: {
    list: (params?: SalaryPageParams) => {
      return httpClient.get<Response<SalaryData>>('/admin/salaries', { params });
    },

    create: (data: CreateSalaryData) => {
      return httpClient.post<Response<Salary>>('/admin/salaries', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<Salary>>(`/admin/salaries/${id}`);
    },

    update: (id: number, data: Partial<CreateSalaryData>) => {
      return httpClient.put<Response<Salary>>(`/admin/salaries/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<Salary>>(`/admin/salaries/${id}`);
    },

    batchUpdateStatus: (data: BatchUpdateSalaryStatusData) => {
      return httpClient.patch<Response<any>>('/admin/salaries/batch-status', data);
    },

    getStats: (params?: { year?: number; month?: number }) => {
      return httpClient.get<Response<SalaryStatsData>>('/admin/salaries/stats', { params });
    },
  },

  // 薪资项目分类管理
  salaryCategories: {
    list: (params?: SalaryItemCategoryPageParams) => {
      return httpClient.get<Response<SalaryItemCategoryData>>('/admin/salary-categories', { params });
    },

    create: (data: CreateSalaryItemCategoryData) => {
      return httpClient.post<Response<SalaryItemCategory>>('/admin/salary-categories', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<SalaryItemCategory>>(`/admin/salary-categories/${id}`);
    },

    update: (id: number, data: UpdateSalaryItemCategoryData) => {
      return httpClient.put<Response<SalaryItemCategory>>(`/admin/salary-categories/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<any>>(`/admin/salary-categories/${id}`);
    },
  },
  // 银行账户管理
  bankAccounts: {

    create: (data: CreateBankAccountData) => {
      return httpClient.post<Response<BankAccount>>('/admin/bank-accounts', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<BankAccount>>(`/admin/bank-accounts/${id}`);
    },

    update: (id: number, data: Partial<CreateBankAccountData>) => {
      return httpClient.put<Response<BankAccount>>(`/admin/bank-accounts/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/admin/bank-accounts/${id}`);
    },

    getByEmployeeId: (employeeId: number) => {
      return httpClient.get<Response<BankAccount[]>>(`/admin/employee-bank-accounts/${employeeId}`);
    },

    setDefault: (employeeId: number, data: SetDefaultBankAccountData) => {
      return httpClient.post<Response<void>>(`/admin/employee-bank-accounts/${employeeId}/set-default`, data);
    },
  },
  // 合同管理
  contracts: {
    create: (data: CreateContractData) => {
      return httpClient.post<Response<Contract>>('/admin/contracts', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<Contract>>(`/admin/contracts/${id}`);
    },

    update: (id: number, data: Partial<CreateContractData>) => {
      return httpClient.put<Response<Contract>>(`/admin/contracts/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/admin/contracts/${id}`);
    },

    getByEmployeeId: (employeeId: number) => {
      return httpClient.get<Response<Contract[]>>(`admin/employee-contracts/${employeeId}`);
    },
  },
  // 消息管理
  messages: {
    list: (params?: MessagePageParams) => {
      return httpClient.get<Response<MessageData>>('/admin/messages', { params });
    },

    create: (data: CreateMessageData) => {
      return httpClient.post<Response<Message>>('/admin/messages', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<Message>>(`/admin/messages/${id}/detail`);
    },

    update: (id: number, data: Partial<CreateMessageData>) => {
      return httpClient.put<Response<Message>>(`/admin/messages/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/admin/messages/${id}`);
    },

    addRecipients: (id: number, data: AddRecipientsData) => {
      return httpClient.post<Response<void>>(`/admin/messages/${id}/recipients`, data);
    },

    sendGlobal: (data: CreateGlobalMessageData) => {
      return httpClient.post<Response<Message>>('/admin/messages/global', data);
    },
  },
  // 权限管理
  permissions: {
    list: (params?: PermissionPageParams) => {
      return httpClient.get<Response<PermissionData>>('/admin/permissions', { params });
    },

    create: (data: CreatePermissionData) => {
      return httpClient.post<Response<Permission>>('/admin/permissions', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<Permission>>(`/admin/permissions/${id}`);
    },

    update: (id: number, data: Partial<CreatePermissionData>) => {
      return httpClient.put<Response<Permission>>(`/admin/permissions/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/admin/permissions/${id}`);
    },

    getRolesByPermission: (permissionName: string) => {
      return httpClient.get<Response<Role[]>>(`/admin/permissions/${permissionName}/roles`);
    },
  },

  // 角色管理
  roles: {
    list: (params?: RolePageParams) => {
      return httpClient.get<Response<RoleData>>('/admin/roles', { params });
    },

    create: (data: CreateRoleData) => {
      return httpClient.post<Response<Role>>('/admin/roles', data);
    },

    detail: (id: number) => {
      return httpClient.get<Response<Role>>(`/admin/roles/${id}`);
    },

    update: (id: number, data: Partial<CreateRoleData>) => {
      return httpClient.put<Response<Role>>(`/admin/roles/${id}`, data);
    },

    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/admin/roles/${id}`);
    },

    assign: (data: RoleAssignData) => {
      return httpClient.post<Response<any>>('/admin/roles/assign', data);
    },

    assignToUser: (data: RoleAssignData) => {
      return httpClient.post('/admin/roles/assign', data);
    },

    revokeFromUser: (data: RoleRevokeData) => {
      return httpClient.post('/admin/roles/revoke', data);
    },

    assignMultipleRoles: async (userId: number, roleNames: string[]) => {
      const results = [];
      for (const role of roleNames) {
        try {
          const result = await httpClient.post('/admin/roles/assign', {
            user_id: userId,
            role: role
          });
          results.push({ role, success: true, result });
        } catch (error) {
          results.push({ role, success: false, error });
        }
      }
      return results;
    },

    revokeMultipleRoles: async (userId: number, roleNames: string[]) => {
      const results = [];
      for (const role of roleNames) {
        try {
          const result = await httpClient.delete('/admin/roles/assign', {
            data: { user_id: userId, role: role }
          });
          results.push({ role, success: true, result });
        } catch (error) {
          results.push({ role, success: false, error });
        }
      }
      return results;
    },

    getUsersByRole: (roleName: string) => {
      return httpClient.get<Response<User[]>>(`/admin/roles/by-name/${roleName}/users`);
    },

    getUserRoles: (userId: number) => {
      return httpClient.get<Response<{ user_id: number, roles: string[] }>>(`/admin/roles/users/${userId}`);
    },

    assignPermission: (data: PermissionAssignData) => {
      return httpClient.post<Response<any>>('/admin/roles/permissions', data);
    },

    addPermission: (data: AddRolePermissionData) => {
      return httpClient.post<Response<null>>('/admin/roles/permissions/add', data);
    },

    addPermissions: async (data: RolePermissionData) => {
      const results = [];
      for (const permission of data.ids) {
        const result = await httpClient.post<Response<any>>('/admin/roles/assign', {
          user_id: data.role_id,
          role: permission.role
        });
        results.push(result);
      }
      return results;
    },

    removePermission: (data: RemoveRolePermissionData) => {
      return httpClient.post<Response<null>>('/admin/roles/permissions/remove', data);
    },

    getPermissions: (roleName: string) => {
      return httpClient.get<Response<RoleData>>(`/admin/roles/by-name/${roleName}/permissions`);
    },
  },

  // 假期审批管理
  leaveRequests: {
    list: (params?: LeaveRequestPageParams) => {
      return httpClient.get<Response<LeaveRequestData>>('/admin/leave-requests', { params });
    },

    detail: (id: number) => {
      return httpClient.get<Response<LeaveRequest>>(`/admin/leave-requests/${id}`);
    },

    approve: (id: number, data: LeaveApprovalData) => {
      return httpClient.post<Response<LeaveRequest>>(`/admin/leave-requests/${id}/approve`, data);
    },

    reject: (id: number, data: LeaveApprovalData) => {
      return httpClient.post<Response<LeaveRequest>>(`/admin/leave-requests/${id}/reject`, data);
    },

    batchApprove: (data: BatchLeaveApprovalData) => {
      return httpClient.post<Response<LeaveRequest[]>>('/admin/leave-requests/batch-approve', data);
    },

    batchReject: (data: BatchLeaveApprovalData) => {
      return httpClient.post<Response<LeaveRequest[]>>('/admin/leave-requests/batch-reject', data);
    },

    getApprovalHistory: (id: number) => {
      return httpClient.get<Response<LeaveApprovalRecord[]>>(`/admin/leave-requests/${id}/approval-history`);
    },
  },

  oss: {
    upload: (data: FormData) => {
      return httpClient.post<{
        data: Response<OSSUploadResponse>
      }>('/oss/upload', data);
    },
  },

  // 假期审批管理（严格按照文档接口）
  leaveApproval: {
    // 获取待审批列表
    getPending: (params?: LeaveRequestPageParams) => {
      return httpClient.get<Response<LeaveRequestData>>('/leave-requests/pending', { params });
    },

    // 获取申请详情
    getDetail: (id: number) => {
      return httpClient.get<Response<LeaveRequest>>(`/leave-requests/${id}`);
    },

    // 审批假期申请
    approve: (id: number, data: LeaveApprovalData) => {
      return httpClient.post<Response<LeaveRequest>>(`/leave-requests/${id}/approve`, data);
    },

    // 批量审批
    batchApprove: (data: BatchLeaveApprovalData) => {
      return httpClient.post<Response<any>>('/leave-requests/batch-approve', data);
    },
  },

  // 排班管理
  schedules: {
    // 获取排班列表
    list: (params?: SchedulePageParams) => {
      return httpClient.get<Response<ScheduleData>>('/schedules', { params });
    },

    // 获取排班详情
    detail: (id: number) => {
      return httpClient.get<Response<Schedule>>(`/schedules/${id}`);
    },

    // 创建单个排班
    create: (data: CreateScheduleData) => {
      return httpClient.post<Response<Schedule>>('/schedules', data);
    },

    // 更新排班
    update: (id: number, data: UpdateScheduleData) => {
      return httpClient.put<Response<Schedule>>(`/schedules/${id}`, data);
    },

    // 删除单个排班
    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/schedules/${id}`);
    },

    // 批量创建排班
    batchCreate: (data: BatchCreateScheduleData) => {
      return httpClient.post<Response<Schedule[]>>('/schedules/batch', data);
    },

    // 批量删除排班
    batchDelete: (data: BatchDeleteScheduleData) => {
      return httpClient.delete<Response<void>>('/schedules/batch', { data });
    },

    // 复制排班
    copy: (data: CopyScheduleData) => {
      return httpClient.post<Response<Schedule[]>>('/schedules/copy', data);
    },

    // 验证排班冲突
    validate: (data: ValidateScheduleData) => {
      return httpClient.post<Response<ScheduleValidationResult>>('/schedules/validate', data);
    },

    // 获取员工列表（用于排班）
    getEmployees: () => {
      return httpClient.get<Response<EmployeeDetail[]>>('/schedules/employees');
    },
  },

  // 班次类型管理
  shiftTypes: {
    // 获取班次类型列表
    list: (params?: ShiftTypePageParams) => {
      return httpClient.get<Response<ShiftTypeData>>('/shift-types', { params });
    },

    // 获取所有启用的班次类型
    getActive: () => {
      return httpClient.get<Response<ShiftTypeData>>('/shift-types?is_active=true');
    },

    // 获取班次类型详情
    detail: (id: number) => {
      return httpClient.get<Response<ShiftType>>(`/admin/shift-types/${id}`);
    },

    // 创建班次类型
    create: (data: CreateShiftTypeData) => {
      return httpClient.post<Response<ShiftType>>('/admin/shift-types', data);
    },

    // 更新班次类型
    update: (id: number, data: Partial<CreateShiftTypeData>) => {
      return httpClient.put<Response<ShiftType>>(`/admin/shift-types/${id}`, data);
    },

    // 删除班次类型
    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/admin/shift-types/${id}`);
    },
  },

  // 假期类型管理
  leaveTypes: {
    // 获取假期类型列表
    list: (params?: LeaveTypePageParams) => {
      return httpClient.get<Response<LeaveTypeData>>('/leave-types', { params });
    },

    // 获取假期类型详情
    detail: (id: number) => {
      return httpClient.get<Response<LeaveType>>(`/admin/leave-types/${id}`);
    },

    // 创建假期类型
    create: (data: CreateLeaveTypeData) => {
      return httpClient.post<Response<LeaveType>>('/admin/leave-types', data);
    },

    // 更新假期类型
    update: (id: number, data: Partial<CreateLeaveTypeData>) => {
      return httpClient.put<Response<LeaveType>>(`/admin/leave-types/${id}`, data);
    },

    // 删除假期类型
    delete: (id: number) => {
      return httpClient.delete<Response<void>>(`/admin/leave-types/${id}`);
    },

    // 更新假期类型状态
    updateStatus: (id: number, is_active: boolean) => {
      return httpClient.put<Response<LeaveType>>(`/admin/leave-types/${id}/status`, { is_active });
    },
  },

}
